module.exports = __webpack_public_path__ + "static/rappers-delight-right-2aee466a6a32aa9b1d26487e2455659e.png";